import React from "react";

import {
  BioWithQuoteAndImage,
  FullscreenFlyoverMap,
  StoryWithImageAndMap,
  FullscreenVideo,
  Credits,
} from "../../components";

import { SLIDE_TYPES } from "../../_constants";

const Slide = ({ slide }) => {
  const renderContentSlide = (type) => {
    if (!type) return Credits;
    switch (type) {
      case SLIDE_TYPES.BIO_WITH_QUOTE_AND_IMAGE:
        return BioWithQuoteAndImage;
      case SLIDE_TYPES.FULLSCREEN_FLYOVER_MAP:
        return FullscreenFlyoverMap;
      case SLIDE_TYPES.STORY_WITH_IMAGE_AND_MAP:
        return StoryWithImageAndMap;
      case SLIDE_TYPES.VIDEO_SLIDE:
        return FullscreenVideo;
      default:
        return Credits;
    }
  };

  const ContentSlide = renderContentSlide(slide?.slideType?.[0]?.__component);

  return (
    <>
      <ContentSlide {...slide} />
    </>
  );
};

export default Slide;
